import { http } from '../utils/http'

// 查询
const searchAction = (params, page, size) => {
    const url = `/config/customer/page`
    return http.post(url, params, page, size)
};

// 新增/修改
const addAction = (params) => {
    const url = `/config/customer/save`
    return http.post(url, params)
};

// 获取详情
const getInfoAction = (id) => {
    const url = `/config/customer/get/${id}`
    return http.post(url)
};

// 删除
const delAction = (id) => {
    const url = `/config/customer/delete/${id}`
    return http.post(url)
};

export default {
    searchAction,
    addAction,
    getInfoAction,
    delAction
}